export default {
  brand: 'dateify',
  domain: 'dateify.ru',
  title: 'dateify.ru — бесплатные инструменты для работы с датами',
  description:
    'Быстрые локальные инструменты для работы с датами и временем: Unix timestamp конвертер, разница между датами и другие date-утилиты. Без регистрации и отправки данных на сервер.',
  metrikaId: '110048636',
  ogImage: 'https://dateify.ru/og-image.png',
}
